import { useEffect } from "react";

// Helper SEO systématique : toute page qui l'appelle obtient automatiquement
// title unique + meta description + og:title = title + og:description + robots index,follow.
// (canonical + og:url self-référentiels gérés par SeoCanonical dans App.js)
// « New city → auto SEO landing » : voir /app/memory/NEW_CITY_SEO.md
export function usePageTitle(title, description) {
  useEffect(() => {
    const ensure = (selector, create) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = create();
        document.head.appendChild(el);
      }
      return el;
    };
    if (title) {
      document.title = title;
      ensure('meta[property="og:title"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("property", "og:title");
        return m;
      }).setAttribute("content", title);
    }
    if (description) {
      const md = document.querySelector('meta[name="description"]');
      if (md) md.setAttribute("content", description);
      const ogd = document.querySelector('meta[property="og:description"]');
      if (ogd) ogd.setAttribute("content", description);
    }
    ensure('meta[name="robots"]', () => {
      const m = document.createElement("meta");
      m.setAttribute("name", "robots");
      return m;
    }).setAttribute("content", "index, follow");
  }, [title, description]);
}
